import {Modal} from 'antd';
import cn from 'classnames';
import React, {ReactNode, FC} from 'react';

import {IFormEntityMeta, selectMetadata} from 'entities/metadata';
import {ReactComponent as CloseIcon} from 'shared/assets/close.svg';
import {EEntityType} from 'shared/constants/entities';
import {DEFAULT_FORM_MODAL_WIDTH, DEFAULT_FORM_WITH_TABS_MODAL_WIDTH} from 'shared/constants/layout';
import {convertWidthData} from 'shared/utils/convert-width-data';
import {useAppSelector} from 'store/config/hooks';
import {TModalComponentInterface} from 'store/slices/modals-slice';

import {FormCloseWarning} from '../form-close-warning';

import './form-modal.less';

interface IFormModalWrapperProps extends TModalComponentInterface {
    children: (handleClose: () => void) => ReactNode;
    hasTitle?: boolean;
    entityName: string;
}

export const FormModalWrapper: FC<IFormModalWrapperProps> = ({
    onClose,
    children,
    hasTitle = true,
    entityName,
}: IFormModalWrapperProps) => {
    const metadata: IFormEntityMeta = useAppSelector(selectMetadata(entityName, EEntityType.FORM));
    const editFormMetadata = useAppSelector(selectMetadata(entityName, EEntityType.EDIT_FORM));

    const modalWidth = convertWidthData(metadata?.width);
    const defaultWidth = metadata?.tabs?.length ? DEFAULT_FORM_WITH_TABS_MODAL_WIDTH : DEFAULT_FORM_MODAL_WIDTH;

    return (
        <FormCloseWarning
            entityName={entityName}
            onClose={onClose}
            metadata={metadata || editFormMetadata}
        >
            {(handleClose, visible: boolean) => (
                <Modal
                    className="form-modal"
                    footer={null}
                    destroyOnClose={false}
                    visible={visible}
                    width={modalWidth || defaultWidth}
                    onCancel={handleClose}
                    maskClosable={false}
                    closeIcon={<CloseIcon className={cn('modal-close-icon', hasTitle && 'with-title')} />}
                    centered
                >
                    {children(handleClose)}
                </Modal>
            )}
        </FormCloseWarning>
    );
};
